<template>
  <div>
    <el-tabs v-model="qdtab" style="margin-right: 40px;margin-left: 40px;">
      <el-tab-pane label="班级分类" name="classtype">
        <el-row class="querypanel">
          <el-col :span="8">
            <div class="leftpanel">
              <div>班级分类列表:</div>
              <el-tree
                class="filter-tree"
                show-checkbox
                node-key="id"
                ref="class_tree_list"
                :data="class_usergroupsdata"
                :props="class_defaultProps"
                :check-strictly = "true"
                default-expand-all
                :expand-on-click-node="false"
                :render-content="class_renderugcontext">
              </el-tree>
              <div class="desinfo"> *请先增加总分类，然后依次增加，注意总分类只能有一个，总分类下可以设置三级子分类。</div>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="rightpanel">
              <el-collapse v-model="class_activeNames" accordion >
                <el-collapse-item title="总分类" name="0">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="总分类">
                      <el-input v-model="class_gsbminfo"></el-input>
                    </el-form-item>
                    <el-form-item label="新增一级分类">
                      <el-input v-model="class_nameone" placeholder="仅新增一级分类时添加"></el-input>
                    </el-form-item>
                    <el-button @click="class_addzero">新增总分类</el-button>
                    <el-button @click="class_changezero">修改并保存</el-button>
                    <el-button @click="class_addone">新增一级子分类</el-button>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="一级分类" name="1">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前一级分类">
                      <el-input v-model="class_gsbmone"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="class_indexone"></el-input>
                    </el-form-item>
                    <el-form-item label="新增二级分类">
                      <el-input v-model="class_nametwo" placeholder="仅新增二级分类时添加"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="class_changeone">修改并保存</el-button>
                      <el-button @click="class_addtwo">新增二级分类</el-button>
                    </el-form-item>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="二级分类" name="2">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前二级分类">
                      <el-input v-model="class_gsbmtwo"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="class_indextwo"></el-input>
                    </el-form-item>
                    <el-form-item label="新增三级分类">
                      <el-input v-model="class_namethree" placeholder="仅新增三级分类添加"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="class_changetwo">修改并保存</el-button>
                      <el-button @click="class_addthree">新增三级分类</el-button>
                    </el-form-item>
                    <div>

                    </div>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="三级分类" name="3">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前三级分类">
                      <el-input v-model="class_gsbmthree"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="class_indexthree"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="class_changethree">修改并保存</el-button>
                    </el-form-item>
                  </el-form>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="班级信息" name="classinfo">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-col :span="12">
              <el-form ref="form"  label-width="100px" label-position="left" >
                <el-form-item label="班级名称">
                  <el-input v-model="class_name" placeholder="请输入班级的关键字"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form ref="form"  label-width="100px" style="margin-left: 20px" label-position="left" >
                <el-form-item label="班级分类">
                  <el-select v-model="class_type" filterable placeholder="请选择班级类别" height="120px">
                    <el-option
                      v-for="item in class_type_list"
                      :key="item.id.Int64"
                      :label="item.name.String"
                      :value="item.id.Int64">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button @click="query_class">查找班级</el-button>
              <el-button @click="add_newclass">添加新班级</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_class"
            ref="multipleTable">
            <el-table-column
              prop="id.Int64"
              label="班级编号">
            </el-table-column>
            <el-table-column
              prop="cname.String"
              width="180px"
              label="班级名">
            </el-table-column>
            <el-table-column
              prop="ctype"
              label="类别ID">
            </el-table-column>
            <el-table-column
              prop="teacherlist.String"
              label="讲师ID列表">
            </el-table-column>
            <el-table-column
              prop="courselist.String"
              label="课程ID列表">
            </el-table-column>
            <el-table-column
              prop="agearea.String"
              label="适合年龄段">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="30px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑班级信息" placement="top-start">
                  <i class="fa fa-edit fa-lg opicon curpointer" v-on:click="edit_class(scope.$index, data_class)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除班级" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_class(scope.$index, data_class)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-dialog title="班级信息" :visible.sync="vis_class_edit">
        <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
          <el-form-item label="班级名称">
            <el-input  v-model="ed_class_name" placeholder="请输入班级名称"></el-input>
          </el-form-item>
          <el-form-item label="所属分类">
            <el-select v-model="ed_class_type" filterable placeholder="请选择班级分类" height="120px">
              <el-option
                v-for="item in class_type_list"
                :key="item.id.Int64"
                :label="item.name.String"
                :value="item.id.Int64">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适合年龄段">
            <el-input v-model="ed_class_age" placeholder="请输入班级适合的年龄段"></el-input>
          </el-form-item>
          <el-row style="margin-top: 20px;">
            <el-col :span="12" >
              <ul class="infinite-list"  style="height: 240px; overflow:auto">
                <el-tree
                  class="filter-tree"
                  show-checkbox
                  node-key="id"
                  ref="teacher_tree_list_ex"
                  :data="teacher_data"
                  :props="course_defaultProps"
                  :check-strictly = "true"
                  default-expand-all
                  :expand-on-click-node="false">
                </el-tree>
              </ul>
            </el-col>
            <el-col :span="12" >
              <ul class="infinite-list"  style="height: 240px; overflow:auto">
                <el-tree
                  class="filter-tree"
                  show-checkbox
                  node-key="id"
                  ref="course_tree_list_ex"
                  :data="course_data"
                  :props="course_defaultProps"
                  :check-strictly = "true"
                  default-expand-all
                  :expand-on-click-node="false">
                </el-tree>
              </ul>
            </el-col>
          </el-row>
          <!--- >
          <el-form-item label="上传班级头像" class="yyzz_upload">
            <el-upload
              class="avatar-uploader"
              multiple
              drag
              action=""
              :headers="uploadHeaders"
              :show-file-list="true"
              :http-request="fnUploadRequest"
              :on-success="OnJSTXResourceSuccess">
              <img v-if="ifportraitok" :src="portraiturl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="头像地址">
            <el-input v-model="ed_class_txaddress" placeholder="请输入头像地址"></el-input>
          </el-form-item>
          <el-form-item label="班级昵称">
            <el-input v-model="ed_class_nickname" placeholder="请输入班级昵称"></el-input>
          </el-form-item>
          <el-form-item label="班级文字简介">
            <el-input v-model="ed_class_jj" placeholder="请输入班级文字简介"></el-input>
          </el-form-item>
          <el-form-item label="上传身份证正面" class="yyzz_upload">
            <el-upload
              class="avatar-uploader"
              drag
              action=""
              :headers="uploadHeaders"
              :show-file-list="true"
              :http-request="fnUploadRequest"
              :on-success="OnIdCardZResourceSuccess">
              <img v-if="idcardzurlok" :src="idcardzurl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传身份证反面" class="yyzz_upload">
            <el-upload
              class="avatar-uploader"
              drag
              action=""
              :headers="uploadHeaders"
              :show-file-list="true"
              :http-request="fnUploadRequest"
              :on-success="OnIdCardFResourceSuccess">
              <img v-if="idcardfurlok" :src="idcardfurl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="班级图文简介:" >
            <quill-editor
              v-model="descontext"
              ref="myQuillEditor"
              :options="editorOption"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </el-form-item>
          --->
          <el-button style="margin-top:20px;" class="gibasebtn" @click="save_classinfo">保存班级</el-button>
        </el-form>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Utils from '../../util/utils'
import '../../../static/css/my.css'
import global_ from '../../store/modules/ossparams.vue'
import * as Quill from 'quill'
import Video from '../../util/video'
import {quillRedefine} from 'vue-quill-editor-upload'
import {quillEditor} from 'vue-quill-editor'
Vue.config.productionTip = false
// 注册 vue-kikindeditor plugin
Quill.register(Video, true)
Vue.prototype.$http = axios
var OSS = require('ali-oss')
var that
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{'header': 1}, {'header': 2}],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{ script: 'sub' }, { script: 'super' }],
  [{'indent': '-1'}, {'indent': '+1'}],
  [{'direction': 'rtl'}],
  [{'size': ['small', false, 'large', 'huge']}],
  [{'header': [1, 2, 3, 4, 5, 6, false]}],
  [{'color': []}, {'background': []}],
  [{'font': []}],
  [{'align': []}],
  ['link', 'image', 'video'],
  ['clean']
]
export default {
  components: {quillEditor, quillRedefine},
  name: 'ClassMana',
  beforeCreate: function () {
    that = this
    console.log('开始创建')
  },
  data () {
    return {
      class_usergroupsdata: [],
      khid: '',
      qdtab: 'classinfo',
      class_activeNames: [],
      class_selectnode: [],
      teacher_data: [],
      course_data: [],
      loading: false,
      class_gsbminfo: '',
      class_gsbmone: '',
      class_gsbmtwo: '',
      class_gsbmthree: '',
      class_nameone: '',
      class_nametwo: '',
      class_namethree: '',
      class_indexone: '',
      class_indextwo: '',
      class_indexthree: '',
      class_treereccount: 0,
      class_defaultProps: {
        children: 'Children',
        label: 'name'
      },
      course_defaultProps: {
        children: 'Children',
        label: 'name'
      },
      class_name: '',
      data_class: [],
      class_type_list: [],
      ed_class_name: '',
      ed_class_type: '',
      ifportraitok: '',
      portraiturl: '',
      data_des: [],
      editorOption: {},
      ed_class_age: '',
      activeName: '1',
      ed_class_jj: '',
      ed_class_nickname: '',
      ed_class_txaddress: '',
      idcardzurlok: false,
      idcardzurl: '',
      idcardfurlok: false,
      idcardfurl: '',
      descontext: '',
      class_type: '',
      vis_class_edit: false,
      selectpath: 'dfsd/class/', /// 上传路径
      selectclass: '',
      ifedit: false,
      vis_upfilepanel: false,
      select_uppathtitle: '',
      upfiletype: '',
      uploadHeaders: { /// 上传参数头
        authorization: ''
      },
      files: 50
    }
  },
  created: function () {
    this.editorOption =
      {
        uploadConfig: {
          methods: 'POST',
          res: (respnse) => {
            console.log(respnse)
            return respnse.info
          }
        },
        methods: 'POST',
        size: 5100,
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
        // input点击事件  formData是提交的表单实体
        change: (formData) => {
        },
        // 设置请求头 xhr: 异步请求， formData: 表单对象
        header: (xhr, formData) => {
          // xhr.setRequestHeader('myHeader','myValue');
          // formData.append('token', '1234')
        },
        // start: function (){}
        start: () => {
        },
        end: () => {
        },
        success: () => {
          console.log('上传成功')
        },
        error: () => {
        },
        placeholder: '请在此输入内容',
        theme: 'snow',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'image': function (value) {
                that.vis_upfilepanel = true
                that.select_uppathtitle = '上传图片'
                that.upfiletype = 'image'
              },
              'video': function (value) {
                that.vis_upfilepanel = true
                that.select_uppathtitle = '上传视频'
                that.upfiletype = 'video'
              }
            }
          }
        }
      }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/gtct',
        method: 'post',
        data: {
          cusid: parseInt(v),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.class_usergroupsdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/qbct',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by id desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取班级数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.class_type_list = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      that.$options.methods.getcoursedata()
      that.$options.methods.getteacherdata()
    }
  },
  methods: {
    onEditorChange: function (val) {
      window.console.log(val)
    },
    getcoursedata () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/gtct',
        method: 'post',
        data: {
          cusid: parseInt(that.khid),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.course_data = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getteacherdata () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/gttt',
        method: 'post',
        data: {
          cusid: parseInt(that.khid),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.teacher_data = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    class_renderugcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o gtopicon" on-click={ () => this.class_edit(node, data)}> </i>
            <i class="fa fa-trash-o gtopicon" on-click={ () => this.class_remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    class_edit (node, data) {
      console.log(node)
      console.log(data)
      this.class_selectnode = data
      this.class_activeNames = [data.level.toString()]
      switch (data.level) {
        case 0: {
          that.class_gsbminfo = data.name
          break
        }
        case 1: {
          that.class_gsbmone = data.name
          that.class_indexone = data.sortindex
          break
        }
        case 2: {
          that.class_gsbmtwo = data.name
          that.class_indextwo = data.sortindex
          break
        }
        case 3: {
          that.class_gsbmthree = data.name
          that.class_indexthree = data.sortindex
          break
        }
      }
    },
    class_remove (node, data) {
      console.log(node)
      console.log(data)
      var idlist = []
      if (data.haschild === 0) {
        idlist.push(data.id)
      } else {
        idlist.push(data.id)
        var cnode = data.Children
        for (var index in cnode) {
          console.log(cnode[index])
          idlist.push(cnode[index].id)
          if (cnode[index].haschild === 0) {
          } else {
            var cinode = cnode[index].Children
            for (var i in cinode) {
              idlist.push(cinode[i].id)
              if (cinode[i].haschild === 0) {
              } else {
                var ciinode = cinode[i].Children
                for (var j in ciinode.Children) {
                  idlist.push(ciinode.Children[j].id)
                  if (cinode[i].haschild === 0) {
                  } else {
                    for (var k in ciinode.Children) {
                      idlist.push(ciinode.Children[k].id)
                    }
                  }
                }
              }
            }
          }
        }
      }
      var idstr = 'id in (' + idlist + ')'
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/dbct',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/class/gtct',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  that.class_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    class_changezero () {
      console.log(this.class_selectnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/aaubct',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.class_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.class_gsbminfo, Valid: true},
          level: parseInt(this.class_selectnode.level),
          haschild: parseInt(this.class_selectnode.haschild),
          parentid: parseInt(-1)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/class/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.class_usergroupsdata = JSON.parse(res.data.data)
                if (res.data.success) {
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    class_addzero () {
      if (that.class_treereccount <= 0) {
        that.$http({
          url: 'https://api.sqnetsoft.cn/class/aaubct',
          method: 'post',
          data: {
            cusid: parseInt(that.khid),
            name: {String: that.class_gsbminfo, Valid: true},
            level: parseInt(0),
            haschild: parseInt(0),
            parentid: parseInt(-1)
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/class/gtct',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    that.$message({
                      type: 'success',
                      message: '添加成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'error',
          message: '只能保留一个总类!'
        })
      }
    },
    class_changeone () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/aaubct',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.class_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.class_gsbmone, Valid: true},
          level: parseInt(this.class_selectnode.level),
          haschild: parseInt(this.class_selectnode.haschild),
          parentid: parseInt(this.class_selectnode.parentid),
          sortindex: parseInt(this.class_indexone)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/class/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.class_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    class_changetwo () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/aaubct',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.class_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.class_gsbmtwo, Valid: true},
          level: parseInt(this.class_selectnode.level),
          haschild: parseInt(that.class_selectnode.haschild),
          parentid: parseInt(that.class_selectnode.parentid),
          sortindex: parseInt(this.class_indextwo)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/class/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.class_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    class_changethree () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/aaubct',
        method: 'post',
        data: {
          id: {Int64: parseInt(that.class_selectnode.id), Valid: true},
          cusid: parseInt(that.khid),
          name: {String: that.class_gsbmthree, Valid: true},
          level: parseInt(that.class_selectnode.level),
          haschild: parseInt(that.class_selectnode.haschild),
          parentid: parseInt(that.class_selectnode.parentid),
          sortindex: parseInt(this.class_indexthree)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/class/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.class_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    class_addone () {
      console.log(this.class_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.class_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.class_gsbminfo, Valid: true},
        level: parseInt(this.class_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.class_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.class_nameone, Valid: true},
        level: parseInt(this.class_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.class_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/paauct',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/class/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.class_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    class_addtwo () {
      console.log(this.class_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.class_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.class_gsbmone, Valid: true},
        level: parseInt(this.class_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.class_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.class_nametwo, Valid: true},
        level: parseInt(this.class_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.class_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/paauct',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/class/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.class_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    class_addthree () {
      console.log(this.class_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.class_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.class_gsbmtwo, Valid: true},
        level: parseInt(this.class_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.class_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.class_namethree, Valid: true},
        level: parseInt(this.class_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.class_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/paauct',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/class/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.class_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_class: function () {
      console.log('查询班级')
      var qstr = 'cusid =' + that.khid
      if (that.class_name !== null && that.class_name !== '') {
        qstr = qstr + " and cname like '%" + that.class_name + "%' "
      }
      if (that.class_type !== null && that.class_type !== '' && that.class_type !== 1) {
        qstr = qstr + ' and find_in_set(' + that.class_type + ', ctype)'
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/qbci',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取班级数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_class = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    add_newclass: function () {
      console.log('增加新班级')
      this.vis_class_edit = true
      this.ifedit = false
      this.ed_class_name = ''
      this.ed_class_age = ''
      this.ed_class_type = ''
      setTimeout(() => {
        console.log(that.$refs.course_tree_list_ex)
        that.$refs.course_tree_list_ex.setCheckedKeys([])
      }, 0)
      setTimeout(() => {
        console.log(that.$refs.teacher_tree_list_ex)
        that.$refs.teacher_tree_list_ex.setCheckedKeys([])
      }, 0)
      this.ifedit = false
    },
    edit_class: function (index, data) {
      console.log(data[index])
      this.selectclass = data[index]
      this.vis_class_edit = true
      this.ed_class_name = this.selectclass.cname.String
      this.ed_class_type = parseInt(this.selectclass.ctype)
      var tmpdata = this.selectclass.courselist.String.split(',')
      var smdata = []
      for (let index in tmpdata) {
        smdata.push(tmpdata[index])
      }
      setTimeout(() => {
        console.log(that.$refs.course_tree_list_ex)
        that.$refs.course_tree_list_ex.setCheckedKeys(tmpdata)
      }, 0)
      var tmpdata1 = this.selectclass.teacherlist.String.split(',')
      var smdata1 = []
      for (let index in tmpdata1) {
        smdata1.push(tmpdata1[index])
      }
      setTimeout(() => {
        console.log(that.$refs.course_tree_list_ex)
        that.$refs.teacher_tree_list_ex.setCheckedKeys(tmpdata1)
      }, 0)
      this.ifedit = true
      this.ed_class_age = this.selectclass.agearea.String
    },
    del_class: function (index, data) {
      console.log(data[index])
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/dbci',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    save_classinfo: function () {
      console.log('保存班级')
      console.log(this.ed_class_name)
      console.log(this.ed_class_type)
      console.log(this.ed_class_age)
      let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
      var adddata
      var gtlisttmp = this.$refs.course_tree_list_ex.getCheckedKeys()
      var owncoursetype = []
      for (var gtindex in gtlisttmp) {
        var gtinfotmp = gtlisttmp[gtindex]
        owncoursetype.push(gtinfotmp)
      }
      var ttlisttmp = this.$refs.teacher_tree_list_ex.getCheckedKeys()
      var ownteachertype = []
      for (var ttindex in ttlisttmp) {
        var ttinfotmp = ttlisttmp[ttindex]
        ownteachertype.push(ttinfotmp)
      }
      console.log(addtime)
      if (this.ifedit) {
        adddata = {
          id: {Int64: parseInt(this.selectclass.id.Int64), Valid: true},
          cname: {String: this.ed_class_name, Valid: true},
          ctype: parseInt(this.ed_class_type),
          courselist: {String: owncoursetype.join(','), Valid: true},
          teacherlist: {String: ownteachertype.join(','), Valid: true},
          agearea: {String: this.ed_class_age, Valid: true},
          cusid: parseInt(this.khid)
        }
      } else {
        adddata = {
          cname: {String: this.ed_class_name, Valid: true},
          ctype: parseInt(this.ed_class_type),
          courselist: {String: owncoursetype.join(','), Valid: true},
          teacherlist: {String: ownteachertype.join(','), Valid: true},
          agearea: {String: this.ed_class_age, Valid: true},
          cusid: parseInt(this.khid)
        }
      }

      that.$http({
        url: 'https://api.sqnetsoft.cn/class/aaubci',
        method: 'post',
        data: adddata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.vis_class_edit = false
            that.$options.methods.query_class()
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    onContentChange: function (val) {
      this.descontext = val
    },
    async OnJSTXResourceSuccess (res, file, fileList) {
      if (res.res.status === 200) {
        this.ed_class_txaddress = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        this.ifportraitok = true
        this.portraiturl = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
      }
    },
    async OnIdCardZResourceSuccess (res, file, fileList) {
      if (res.res.status === 200) {
        this.idcardzurlok = true
        this.idcardzurl = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
      }
    },
    async OnIdCardFResourceSuccess (res, file, fileList) {
      if (res.res.status === 200) {
        this.idcardfurlok = true
        this.idcardfurl = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
      }
    },
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },

    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: global_.ACCESSKEYID,
          accessKeySecret: global_.ACCESSKEYSECRET,
          bucket: global_.BUCTKE
        })
        resolve(client)
      })
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @author   yangxiaoshuo
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = global_.Teacher + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    /**
     * @description [fnUploadSuccess 文件上传成功的函数]
     * @author   shanshuizinong
     * @return   {null}  [没有返回]
     */
    async fnUploadSuccess (res, file, fileList) {
      console.log(res)
      if (res.res.status === 200) {
        var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        console.log(uppath)
        console.log(this.upfiletype)
        if (this.upfiletype === 'image') {
          this.descontext = this.descontext + '<p><img src="' + uppath + '"></p>'
        } else {
          this.descontext = this.descontext + '<video class="videoinfo" id="videoinfo" src="' + uppath + '" controls="controls" loop="loop"> </video>'
        }
        console.log(this.descontext)
      }
      // TODO
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/class/ClassMana.vue